module.exports = __webpack_public_path__ + "static/media/boca-photo-4.861456d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/boca-photo-4.jpg
// module id = 2085
// module chunks = 0